import { Country } from "../country";

export const COUNTRY_1 = new Country(2, 'Brasil');
export const COUNTRY_2 = new Country(1, 'EUA');
export const COUNTRY_3 = new Country(3, 'Chile');
export const COUNTRY_4 = new Country(4, 'Istanbul');
export const COUNTRY_5 = new Country(5, 'Paris');

// export const COUNTRY_LIST = [COUNTRY_1, COUNTRY_2, COUNTRY_3, COUNTRY_4, COUNTRY_5]
export const COUNTRY_LIST = [COUNTRY_1, COUNTRY_2]